function injectLoadAnim() {
    const checkboxes = document.querySelectorAll(".checkbox--custom-loader");
    let loader = document.createElement("div");
    loader.classList.add("loader");

    checkboxes.forEach((checkbox) => {
        let child = checkbox.querySelector(".sk-option-list");
        child.parentNode.insertBefore(loader, child.nextSibling);
    })
}

export { injectLoadAnim };